var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"component-link-big",attrs:{"href":_vm.specificData.href}},[_vm._v(" "+_vm._s(_vm.specificData.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }